export default {
  GET_ROUTE (state) {
    return state.route
  },
  GET_DRAWER (state) {
    return state.drawer
  },
  GET_ROLE (state) {
    return state.role
  },
  GET_ALERT (state) {
    return state.alert
  },
  GET_USER (state) {
    return state.user
  },
  GET_DIALOG (state) {
    return state.dialog
  },
  GET_LANG (state) {
    return state.lang
  },
  GET_STATISTIC (state) {
    return state.statistic
  },
  GET_LOADING (state) {
    return state.loading
  },
  GET_WEBSITE (state) {
    return state.website
  },
  GET_NEW_SUBSCRIBER_DIALOG (state) {
    return state.newSubscriberDialog
  },
  GET_UPDATE_SUBSCRIBER_DIALOG (state) {
    return state.updateSubscriberDialog
  },
  GET_SUBSCRIBER (state) {
    return state.subscriber
  }
}
